// extracted by mini-css-extract-plugin
export default {"pl":"LoaderBig_pl__+lN4Q","pl__ring":"LoaderBig_pl__ring__3ub-2","pl__ball":"LoaderBig_pl__ball__Xy00L","ring":"LoaderBig_ring__QlJLF","ball":"LoaderBig_ball__JL3bN"};